import { useTranslation } from "react-i18next";

const Privacy = () => {
  const { t } = useTranslation();
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <h1 className="text-[24px] md:text-[32px] text-mainBlue space-y-10 font-semibold text-center">
            {t("privacyPolicy")}
          </h1>
          <section className="space-y-10">
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("1introduction")}
              </h2>
              <p className="font-medium text-mainGray">
                {t("megtlogisticsIsCommitted")}
              </p>
              <p className="font-medium text-mainGray">{t("byUsingOurWebsite")}</p>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("2informationWeCollect")}
              </h2>
              <p className="font-medium text-mainGray">{t("weMayCollect")}</p>
              <p className="font-medium text-black">{t("aPersonalInfo")}</p>
              <p className="font-medium text-mainGray">{t("fullName.")}</p>
              <p className="font-medium text-mainGray">{t("contactInfoSuchAS")}</p>
              <p className="font-medium text-mainGray">
                {t("shippingAndDeliveryDetails")}
              </p>
              <p className="font-medium text-mainGray">{t("financialInfo")}</p>
              <p className="font-medium text-mainGray">{t("anyAdditionalInfo")}</p>

              <p className="font-medium text-black">{t("bNonPersonalInfo")}</p>

              <p className="font-medium text-mainGray">{t("browsingData")}</p>
              <p className="font-medium text-mainGray">{t("cookiesAndOther")}</p>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("howWeUseInfo")}
              </h2>
              <p className="font-medium text-mainGray">{t("infoUsedForPurposes")}</p>
              <p className="font-medium text-mainGray">
                {t("providingShippingServices")}
              </p>
              <p className="font-medium text-mainGray">{t("processingPayments")}</p>
              <p className="font-medium text-mainGray">
                {t("communicationResponding")}
              </p>
              <p className="font-medium text-mainGray">
                {t("legalComplianceEnsuring")}
              </p>
              <p className="font-medium text-mainGray">{t("serviceImprovement")}</p>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("infoSharing")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("megtlogisticsIsCommittedTo")}</p>

                <p>{t("transportAndPartners")}</p>
                <p>{t("itService")}</p>
                <p>{t("legalAndRegular")}</p>
                <p>{t("otherRelevantEntities")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("infoProtection")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("weFollowStrictSecurity")}</p>
                <p>{t("usingEncryption")}</p>
                <p>{t("implementingFirewalls")}</p>
                <p>{t("regularlyReviewing")}</p>
                <p>{t("pleaseNote")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("dataRetention")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("weRetainURPersonalData")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("cookiesAndTracking")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("megtlogisticsWebsites")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("userRights")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("uHaveRightTo")}</p>
                <p>{t("dataAccessRight")}</p>
                <p>{t("dataCorrectionRight")}</p>
                <p>{t("dataDeletionRight")}</p>
                <p>{t("objectionToProcessing")}</p>
                <p>{t("uCanExerciseRights")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("changesToPolicy")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("weMayUpdate")}</p>
              </div>
            </div>
            <div>
              <h2 className="text-mainRed text-[20px] md:text-[24px] font-bold my-4">
                {t("10contactUs")}
              </h2>
              <div className="font-medium text-mainGray">
                <p>{t("ifUHaveInquiries")}</p>

                <p>{t("email-")} [info@MiddleEastGT.com] </p>
                <p>{t("phone-")} [+90 552 797 77 72] </p>
                <p>{t("address-")} [around the world, Mersin] </p>
              </div>
            </div>
            <div>
              <p className="text-lg font-semibold text-mainBlue">{t("disclaimer")}</p>
              <p className="text-lg font-semibold text-mainBlue">
                {t("thisPolicyIsPart")}
              </p>
            </div>
          </section>
        </div>
      </article>
    </main>
  );
};

export default Privacy;
